import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface WarningProps {
  mainColor?: string;
  secondaryColor?: string;
  style?: React.CSSProperties;
}

export const WarningIcon = ({
  mainColor = RoutalPalette.warning.medium,
  secondaryColor = RoutalPalette.neutral02n,
  style = {},
  ...props
}: WarningProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 21" fill="none" style={{ width: `21px`, height: `21px`, ...style }}>
      <g clipPath="url(#clip0_296_32583)">
        <path
          d="M8.7497 3.41374L1.69137 15.1971C1.54584 15.4491 1.46884 15.7348 1.46802 16.0258C1.46721 16.3169 1.54261 16.603 1.68672 16.8558C1.83084 17.1087 2.03864 17.3194 2.28946 17.4669C2.54027 17.6145 2.82537 17.6939 3.11637 17.6971H17.233C17.524 17.6939 17.8091 17.6145 18.0599 17.4669C18.3108 17.3194 18.5186 17.1087 18.6627 16.8558C18.8068 16.603 18.8822 16.3169 18.8814 16.0258C18.8806 15.7348 18.8036 15.4491 18.658 15.1971L11.5997 3.41374C11.4511 3.16883 11.242 2.96634 10.9924 2.82581C10.7428 2.68528 10.4611 2.61145 10.1747 2.61145C9.88825 2.61145 9.60664 2.68528 9.35704 2.82581C9.10743 2.96634 8.89826 3.16883 8.7497 3.41374Z"
          fill={mainColor}
          stroke={mainColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.1748 7.69702V11.0304" stroke={secondaryColor} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.1748 14.3636H10.1831"
          stroke={secondaryColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_296_32583">
          <rect width="20" height="20" fill={secondaryColor} transform="translate(0.174805 0.197021)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
